module.exports = __webpack_public_path__ + "a5cd82517d73b8dfd1179cccc4760dde.pdf";